import * as React from "react"

const ContentSeparator = () => (
  <div className="section-separator">
    <span className="fl-wrap" />
  </div>
)

export default ContentSeparator
